import { PhysicalCardEntry } from "components/components/Cards/PhysicalCardEntry";
import React from "react";
import { useState } from "react";
import TranslationText from "components/components/Translation/TranslationText";
import Footer from "components/components/Footer";
import { Link } from "react-router-dom/cjs/react-router-dom";
import AutoHideableTitle from "components/components/HeaderComponents/AutoHideableTitle";
import PhysicalCardConfirmationService from "components/services/PhysicalCardConfirmationService.js";
import i18n from "translations/i18n.jsx";
import { DATA_SAVED } from "components/constants/notificationTypes";
import webTools from "components/tools/webTools.js";
import { ChevronLeftIcon } from "components/icons/ChevronLeftIcon";
import { withTranslation } from "react-i18next";
import { NOTIFICATION_QUERY_KEY } from "components/constants/constants";

function PhysicalCardActivation(props) {
  const [errorMessage, setErrorMessage] = useState("");
	const [card, setCard] = useState({
		cardPrefix: "",
    cardNumber: ""});
	const [activateButtonEnabled, setActivateButtonEnabled] = useState(false);
  
	const onChange = (card) => {
		const isCardValid = PhysicalCardConfirmationService.isCardFormatValid(card.cardPrefix, card.cardNumber);

		setActivateButtonEnabled(isCardValid);
		setCard({...card, cardPrefix: card.cardPrefix, cardNumber: card.cardNumber});		
	}

	const onConfirm = async () => {
		setErrorMessage("");
		const isCardValid = validateCard();
		if (!isCardValid) {
			return;
		}
		setActivateButtonEnabled(false);

		const result = await PhysicalCardConfirmationService.confirmPhysicalCard(card.cardPrefix, card.cardNumber);
    
		if (result.isConfirmed) {
			webTools.reloadToRoute(`ProfileInformation?${NOTIFICATION_QUERY_KEY}=${DATA_SAVED}`);
		}
		else {
			setActivateButtonEnabled(true);
			setErrorMessage(result.error);
		}
	}

	const validateCard = () => {
		let isCardValid = true;
		let error = "";
		if (!PhysicalCardConfirmationService.isCardFormatValid(card.cardPrefix, card.cardNumber)) {		
      error = "card_replacement_page_incorrect_card_number_error";
			isCardValid = false;
    }		
		
		if (!isCardValid) {
			setErrorMessage(error);
		}

		return isCardValid;
	}

	return (
		<>
			<div className="container page-container">
				<Link className="link-button -with-left-icon" to="/profileInformation">
					<ChevronLeftIcon />
					<TranslationText text="back_to_profile_btn" />
				</Link>
				<AutoHideableTitle text="activate_physical_card_page_title" />
				<div className="card card-full-width">
					<div className="card-content">
						<div className="page-description-row">
							<p>
								<TranslationText text='activate_physical_card_page_description'/>
							</p>
						</div>
						<hr className="no-margin-top" />
						<div className="row row-center">
							<div className="column-desktop-4 column-tablet-12 column-mobile-12">
								<PhysicalCardEntry initialData={props.initialData} errorMessage={errorMessage} 
									onChange={onChange} />
							</div>
						</div>
						<hr />
						<div className="row button-row">
							<div className="column-medium-3 column-desktop-4 column-tablet-12">
								<button
									onClick={_ => onConfirm()}
									className="button full-width"
									disabled={!activateButtonEnabled}
									title={i18n.t('account_created_page_activation_button_tooltip')}
								>
									<TranslationText text='account_created_page_activation_button_label' />
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Footer countrySelectionEnabled={false} legalEntity={props.initialData.legalEntityId} />
		</>
	);  
}

export default withTranslation()(PhysicalCardActivation);